import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { id: "main" }
const _hoisted_2 = { ref: "topAnchor" }
const _hoisted_3 = { class: "sec-main highlightsP-main bg-gray" }
const _hoisted_4 = { class: "container-lg position-relative" }
const _hoisted_5 = { class: "col-11 col-sm-10 mx-auto" }
const _hoisted_6 = {
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb"
}
const _hoisted_7 = { class: "breadcrumb" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = { class: "breadcrumb-item" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("li", {
  class: "breadcrumb-item active",
  "aria-current": "page"
}, "亮點成果", -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-10 mx-auto" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", { class: "h2 head-row text-white mb-md-5 mb-3" }, "亮點成果", -1)
const _hoisted_14 = { class: "row row-cols-1 row-cols-sm-2 row-cols-md-3 cols-list highlight-list" }
const _hoisted_15 = { class: "event-item bg-white h-100 p-0" }
const _hoisted_16 = { class: "event-card-logo" }
const _hoisted_17 = { class: "event-card-info p-3 border-top" }
const _hoisted_18 = { class: "event-card-date info-text mb-2" }
const _hoisted_19 = { class: "event-card-cate text-primary mb-2" }
const _hoisted_20 = { class: "h5 event-card-title limitLine mb-2" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_pagination_component = _resolveComponent("pagination-component")!
  const _directive_title = _resolveDirective("title")!
  const _directive_body_class = _resolveDirective("body-class")!

  return _withDirectives((_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, null, 512),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("nav", _hoisted_6, [
            _createElementVNode("ol", _hoisted_7, [
              _createElementVNode("li", _hoisted_8, [
                _createVNode(_component_router_link, {
                  to: "/",
                  title: "首頁",
                  class: "foo: false"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("首頁")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_9, [
                _createVNode(_component_router_link, {
                  to: "/list",
                  title: "活動消息",
                  class: "foo: false"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("活動消息")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_10
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.content, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "col align-self-stretch mb-4"
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_router_link, {
                      to: {name: 'achievements-detail', params: { id: item.id }},
                      title: "亮點成果",
                      class: "foo: false"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", {
                            class: "bg-wrapper",
                            style: _normalizeStyle('background-image: url(' + (item.file1 ? item.file1.path : '/resources/images/placeholder-highlight.png') + ')')
                          }, null, 4)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, _toDisplayString(item.date), 1),
                          _createElementVNode("div", _hoisted_19, _toDisplayString(item.title), 1),
                          _createElementVNode("div", _hoisted_20, _toDisplayString(item.content), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_pagination_component, {
              class: "pagination-component",
              totalPages: _ctx.totalPages,
              onOnClick: _ctx.changePage
            }, null, 8, ["totalPages", "onOnClick"])
          ])
        ])
      ])
    ])
  ])), [
    [_directive_title, '亮點成果'],
    [_directive_body_class, ['list-theme', 'highlightsP']]
  ])
}